import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ContractInboundPhone extends Resource {
    public override type = 'contractInboundPhones';

    @prop()
    @required()
    public contractId!: string;

    @prop()
    @required()
    public phone!: string;
    
    @prop()
    public description?: string;
}